// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markdown-control__textarea {
  max-height: 40vh;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/MarkdownControl/MarkdownControl.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR","sourcesContent":[".markdown-control__textarea {\n  max-height: 40vh;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
